/** Rubrique Spécificités (Cave) : gérer la liste des spécificités viticoles (bio, nature…)
 * proposées sur les fiches cuvée. Les valeurs par défaut sont verrouillées ; on peut ajouter
 * et supprimer des spécificités personnalisées. */
import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Trash2, Plus, Lock } from 'lucide-react';
import { parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';
import { InlineEditable } from '../../../components/wine/InlineEditable';

export default function Specificites() {
  const qc = useQueryClient();
  const { data: items = [], isLoading } = useQuery({ queryKey: ['specificities'], queryFn: parametresApi.specificities });
  const [label, setLabel] = useState('');
  const refresh = () => qc.invalidateQueries({ queryKey: ['specificities'] });

  const add = async () => {
    const l = label.trim();
    if (!l) return;
    await parametresApi.addSpecificity(l); setLabel(''); refresh(); toast.success('Spécificité ajoutée');
  };
  const remove = async (key) => { await parametresApi.deleteSpecificity(key); refresh(); toast.success('Spécificité supprimée'); };
  const rename = async (key, label) => { await parametresApi.renameSpecificity(key, label); refresh(); toast.success('Spécificité renommée'); };

  if (isLoading) return <Spinner />;
  return (
    <div className="max-w-[560px]">
      <h2 className="font-title text-3xl mb-1">Spécificités</h2>
      <p className="text-[13px] text-n600 mb-4">Labels et pratiques (bio, biodynamie, nature…) proposés sur les fiches cuvée. Survolez un nom pour le renommer — les associations (bouteilles, domaines) sont conservées.</p>

      <div className="flex items-center gap-2 mb-4">
        <input className="vd-input h-9 flex-1" placeholder="Nouvelle spécificité…" value={label}
          onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') add(); }} data-testid="spec-new-input" />
        <Button variant="primary" onClick={add} data-testid="spec-add"><Plus className="w-4 h-4" /> Ajouter</Button>
      </div>

      <Card className="divide-y divide-hair" data-testid="specificities-list">
        {items.map((s) => (
          <div key={s.key} className="flex items-center gap-3 px-4 py-2.5" data-testid={`spec-row-${s.key}`}>
            <span className="flex-1 text-[14px]">
              <InlineEditable value={s.label} testId={`spec-label-${s.key}`} inputClassName="h-8 text-[14px]"
                onSave={(v) => rename(s.key, v)} />
            </span>
            {s.custom ? (
              <button className="text-n500 hover:text-red-600" title="Supprimer" onClick={() => remove(s.key)} data-testid={`spec-del-${s.key}`}><Trash2 className="w-4 h-4" /></button>
            ) : (
              <span className="text-n400" title="Valeur par défaut (non supprimable, mais renommable)"><Lock className="w-3.5 h-3.5" /></span>
            )}
          </div>
        ))}
      </Card>
    </div>
  );
}
